import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import selectors from "rdx/selectors";
import messages from "rdx/modules/buildPartnerApplications/messages";

function* approveBuildPartnerApplication(action) {
  const { id } = action.payload;

  const { success, data, error } = yield* makeRequest.post(`/labor_partner_applications/${id}/respond`, {
    decision: "approved",
  });

  if (success && data) {
    const applicationDetail = yield select(selectors.selectBuildPartnerApplicationDetail);

    yield all([
      put(
        actions.setBuildPartnerApplicationDetail({
          ...applicationDetail,
          decision: "approved",
        }),
      ),
      put(
        actions.newSuccessEvent({
          message: messages.APPROVE_BUILD_PARTNER_APPLICATION_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_APPROVING_BUILD_PARTNER_APPLICATION,
    });
  }

  return null;
}

export default approveBuildPartnerApplication;
